import { Skeleton, tableHelpers, Tooltip, Badge } from '@round/creatorbase-ui';
import { getMeta, CellContext } from '../../helpers';
import styles from './TagsCell.module.css';
import cn from 'classnames';
import useOverflowingChildren from 'Hooks/useOverflowingChildren';

// Room kept free at the right edge for the "+N" badge so tags never crowd it out of view.
const OVERFLOW_BADGE_RESERVE_PX = 40;

export const TagsCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading } = getMeta(table);
    const isBaseLoading = tableHelpers.isLoadingRow(original) || isLoading;
    const tags = original.influencer_tags ?? [];
    const { ref, overflowingChildren } = useOverflowingChildren<HTMLDivElement>({
        reserveRight: OVERFLOW_BADGE_RESERVE_PX,
    });
    const overflowCount = overflowingChildren.length;

    if (!isBaseLoading && tags.length === 0) {
        return <span className={styles.muted}>-</span>;
    }

    return (
        <Tooltip>
            <Tooltip.Trigger asChild>
                <div ref={ref} className={styles.container}>
                    {isBaseLoading
                        ? Array(3)
                              .fill({})
                              .map((_, i) => <Skeleton className={styles.badgeSkeleton} key={i} />)
                        : tags.map((t) => (
                              <Badge key={t} variant="outline" className={styles.badge}>
                                  {t}
                              </Badge>
                          ))}
                    {overflowCount > 0 && (
                        <Badge data-overflowing="ignore" variant="outline" className={cn(styles.badge, styles.muted)}>
                            +{overflowCount}
                        </Badge>
                    )}
                </div>
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom" className={styles.tooltipContent}>
                <p>{tags.join(', ')}</p>
            </Tooltip.Content>
        </Tooltip>
    );
};
